// Feature flags: Global (apply to all generators) + Per-generator (specific behavior)
// New generators automatically inherit "default" flags (zero-effort scaling)

export type GeneratorSlug = "swms" | "itp" | "rams";

export interface GeneratorFeatureFlags {
  // New analytics: tracks generator_slug + document_type
  // Legacy analytics: hardcoded SWMS context + swms_type
  use_new_analytics: boolean;
  // Future: enable_custom_branding, require_approval_workflow, etc.
}

export interface GlobalFeatureFlags {
  should_show_ai_suggestions: boolean;
  should_show_beta_features: boolean;
  // Future: enable_dark_mode, show_onboarding, enable_telemetry, etc.
}

interface AllFeatureFlags extends GlobalFeatureFlags {
  generators: Record<GeneratorSlug | "default", GeneratorFeatureFlags>;
}

const FEATURE_FLAGS: AllFeatureFlags = {
  // Global flags
  should_show_ai_suggestions: false,
  should_show_beta_features: false,

  // Per-generator flags
  generators: {
    swms: { use_new_analytics: true },  // Now using V2 analytics
    itp: { use_new_analytics: true },   // Validate new system
    rams: { use_new_analytics: true },
    default: { use_new_analytics: true }, // All future generators inherit this
  },
};

export function getFeatureFlagsByGenerator(
  generatorSlug: string
): GeneratorFeatureFlags {
  return (
    FEATURE_FLAGS.generators[generatorSlug as GeneratorSlug] ||
    FEATURE_FLAGS.generators.default
  );
}

export function getGlobalFeatureFlags(): GlobalFeatureFlags {
  return {
    should_show_ai_suggestions: FEATURE_FLAGS.should_show_ai_suggestions,
    should_show_beta_features: FEATURE_FLAGS.should_show_beta_features,
  };
}

export function shouldUseNewAnalytics(generatorSlug: string): boolean {
  return getFeatureFlagsByGenerator(generatorSlug).use_new_analytics;
}
